import React, { createContext, useContext, useState } from 'react';

interface Settings {
  initialCustomers: number;
  monthlyRevenue: number;
  yAxisMaxValue: number;
}

interface SettingsContextType {
  settings: Settings;
  updateSettings: (newSettings: Settings) => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

interface SettingsProviderProps {
  children: React.ReactNode;
  initialSettings?: Partial<Settings>;
}

export function SettingsProvider({ children, initialSettings = {} }: SettingsProviderProps) {
  const [settings, setSettings] = useState<Settings>({
    initialCustomers: initialSettings.initialCustomers ?? 50,
    monthlyRevenue: initialSettings.monthlyRevenue ?? 1500,
    yAxisMaxValue: initialSettings.yAxisMaxValue ?? 1250000,
  });

  const updateSettings = (newSettings: Settings) => {
    setSettings(newSettings);
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
}